import { storeRedirectUrl, useAuth } from '@ocula/auth';
import { useBroadcastChannelSender } from '@ocula/broadcast-channel';
import { useMountEffect } from '@react-hookz/web/esm';
import { useLocation, useSearchParams } from 'react-router-dom';

import { PageSpinner } from '@src/components/Spinner';
import { getFullPathFromLocation } from '@src/utils/routing';

/** The LoginPage is only accessible if the user is not already logged in. */
function LoginPage() {
  const { loginWithRedirect } = useAuth();
  const postMessage = useBroadcastChannelSender();

  const [searchParams] = useSearchParams();
  const invitation = searchParams.get('invitation');
  const organization = searchParams.get('organization');

  const location = useLocation();
  // biome-ignore lint/suspicious/noExplicitAny: TODO: fix
  const from = getFullPathFromLocation((location.state as any)?.from);

  // Trigger the login process for the user.
  useMountEffect(async () => {
    // Signal to any other tabs that the user is logging in and so should be
    // logged out of those other tabs if they are logged in.
    await postMessage({ type: 'logout' });

    if (invitation && organization) {
      loginWithRedirect({ organization, invitation });
    } else {
      // Redirect the user to where they wanted to go before they had to log in.
      loginWithRedirect({ appState: storeRedirectUrl(from) });
    }
  });

  // In reality this spinner is unlikely to be seen by the user because
  // the Auth0 code redirects immediately to the login screen in Auth0's domain.
  return <PageSpinner />;
}

export default LoginPage;
